import React from "react";
import Radium from "radium";
import EventListener from "react-event-listener";

import {
  Checkbox,
} from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import AnalyticsStore from "../stores/AnalyticsStore";
import AnalyticsActions from "../actions/AnalyticsActions";

import AnalyticsHeader from "./partials/analytics-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import GenericAnalyticsTable from "./partials/generic-analytics-table.jsx";
import AnalyticsFilterWidget from "./partials/analytics-filter-widget.jsx";

import moment from "moment";

import * as util from "../util";

class SalesAnalytics extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRangeEditor: false,
      allTime: false,
      range: {
        key: "selection",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      segmentTicketSalesBy: "price", // ['price', 'event', 'type']
      useLedger: false
    };

    this.onWindowClick = this.onWindowClick.bind(this);
    this.onWindowKeyDown = this.onWindowKeyDown.bind(this);
    this.handleSegmentFilterChange = this.handleSegmentFilterChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleLedgerToggleChange = this.handleLedgerToggleChange.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  static getStores() {
    return [EventBucketStore, AnalyticsStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getSalesAnalytics: AnalyticsStore.getSalesAnalytics,
      isFetching: AnalyticsStore.getState().isFetching
    };
  }

  onWindowClick(e) {
    if (
      this.state.showRangeEditor &&
      (!this.container ||
        (!this.container.contains(e.target) &&
          !this.rangeButton.contains(e.target)))
    ) {
      this.setState({ showRangeEditor: false });
    }
  }

  onWindowKeyDown(e) {
    if (this.state.showRangeEditor && e.which === 27) {
      // esc
      this.setState({ showRangeEditor: false });
    }
  }

  handleSegmentFilterChange(props) {
    this.setState({ segmentTicketSalesBy: props },
      () => this.componentWillReceiveProps(this.props, true)
    )
  }

  handleDateChange({ range, allTime }) {
    this.setState({ range: range, allTime: allTime },
      () => this.componentWillReceiveProps(this.props, true)
    );
  }

  handleLedgerToggleChange(props) {
    this.setState({ useLedger: props },
      () => this.componentWillReceiveProps(this.props, true)
    );
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (
      force === true ||
      newProps.params.eventBucketId !== this.props.params.eventBucketId
    ) {
      AnalyticsActions.fetchSalesAnalytics.defer(
        Object.assign(
          { event_bucket: newProps.params.eventBucketId },
          !this.state.allTime && {
            created_at: {
              $gt: moment(this.state.range.startDate).startOf("day"),
              $lte: moment(this.state.range.endDate).endOf("day")
            }
          },
          this.state.allTime && {
            all_time: true
          },
          {
            by_event: this.state.segmentTicketSalesBy === "event",
            by_type: this.state.segmentTicketSalesBy === "type"
          },
          {
            use_new: this.state.useLedger
          }
        )
      );
      if (newProps.params.eventBucketId !== this.props.params.eventBucketId) {
        EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
      }
    }
  }

  render() {
    const { eventBucketId } = this.props.params;
    const eventBucket = this.props.getEventBucketById(eventBucketId);
    const salesAnalytics = this.props.getSalesAnalytics(eventBucketId);
    const defaultItemsPerPage = 25;

    if (!salesAnalytics || !eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    let timePeriod = this.state.allTime
      ? "All time"
      : moment(this.state.range.startDate)
        .twix(this.state.range.endDate, { allDay: true })
        .format({ implicitYear: false });

    return (
      <div>
        <EventListener
          target="window"
          onClick={this.onWindowClick}
          onKeyDown={this.onWindowKeyDown}
        />
        <AnalyticsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label="sales analytics"
          subpath="sales"
          query={this.props.location.query}
          // onRefresh={() => this.componentWillReceiveProps(this.props, true)}
          // isRefreshing={this.props.isFetching}
          hideHeader={true}
        />
        <div style={{ position: "relative" }}>
          <h1 style={{ lineHeight: 1.2 }}>
            "{eventBucket.name}" sales analytics
          </h1>
          <AnalyticsFilterWidget
            showDateFilter={true}
            onDateRangeChange={this.handleDateChange}
            showSegmentFilter={true}
            onSegmentFilterChange={this.handleSegmentFilterChange}
            segmentFilterTitle={"Segment ticket sales by"}
            segmentFilterSelected={this.state.segmentTicketSalesBy}
            segmentFilterConfig={[
              {
                value: "price",
                label: "Price level"
              },
              {
                value: "event",
                label: "Event"
              },
              {
                value: "type",
                label: "Screening type"
              }
            ]}
            showLedgerToggle={true}
            onLedgerToggleChange={this.handleLedgerToggleChange}
          />
          {Object.values(salesAnalytics.data).some(r => !!r.platform_fees) ? (
            <div style={{ margin: "1em 0" }}>
              <Checkbox
                checked={!!this.props.location.query.include_fee_breakdown}
                label="Include fee breakdown"
                style={{ width: 200 }}
                onCheck={(e, checked) =>
                  this.context.router.push({
                    pathname: `/event_buckets/${eventBucketId}/analytics/sales`,
                    query: checked ? { include_fee_breakdown: true } : null
                  })
                }
              />
              {this.props.location.query.include_fee_breakdown ? (
                <div style={{ marginLeft: 40 }}>
                  <i>
                    *Fee difference = net sales variance from face value based
                    on absorbed fees / negotiated rate.
                  </i>
                </div>
              ) : null}
            </div>
          ) : null}

          {salesAnalytics.fromCache ? (
            <div
              style={{
                marginBottom: 12,
                color: "rgba(33, 33, 33, 0.5)",
                fontStyle: "italic"
              }}
            >
              Showing cached results (last updated{" "}
              {salesAnalytics.precomputedAt
                ? new Date(salesAnalytics.precomputedAt).toLocaleString()
                : "unknown"}
              )
            </div>
          ) : null}
          {
            this.props.isFetching || !salesAnalytics || !eventBucket
              ? (
                <div><WorkingIndicator fullPage={true} /></div>
              ) : (
                <div>
                  <GenericAnalyticsTable
                    eventBucket={eventBucket}
                    csvLabel="sales-analytics"
                    showPdfDownload={true}
                    pdfFilename={util.snakeCase(
                      `${eventBucket.name} sales analytics ${timePeriod}`
                    )}
                    pdfTitle={`${eventBucket.name} sales analytics`}
                    pdfSubtitle={`Period: ${timePeriod}`}
                    noSort={true}
                    itemsPerPage={defaultItemsPerPage}
                    columns={[
                      { label: "Category", value: "category" },
                      { label: "Gross sales", value: "gross" }
                    ]
                      .concat(
                        !!this.props.location.query.include_fee_breakdown
                          ? [{ label: "Face value", value: "face_sales" }]
                          : []
                      )
                      .concat([
                        { label: "Net sales", value: "net" },
                        { label: "Fees", value: "fee" }
                      ])
                      .concat(
                        !!this.props.location.query.include_fee_breakdown
                          ? [
                            { label: "Stripe fees", value: "stripe_fees" },
                            { label: "Eventive fees", value: "platform_fees" },
                            //{ label: 'Fees absorbed', value: 'fees_absorbed' },
                            { label: "Fee difference*", value: "fees_difference" }
                          ]
                          : []
                      )
                      .concat(
                        Object.values(salesAnalytics.data).some(v => v.deferred_fee)
                          ? [{ label: "Deferred fees", value: "deferred_fee" }]
                          : []
                      )
                      .concat(
                        this.state.useLedger
                          ? [
                            { label: "Qty Sold", value: "quantity" },
                            { label: "Qty Active", value: "quantity_active" }
                          ]
                          : [{ label: "Quantity", value: "quantity" }]
                      )
                      .concat([
                        { label: "Credit (net)", value: "credit_net" },
                        { label: "Cash", value: "cash" }
                      ])
                      .concat(
                        Object.values(salesAnalytics.data).some(v => v.check)
                          ? [{ label: "Check", value: "check" }]
                          : []
                      )
                      .concat(
                        Object.values(salesAnalytics.data).some(v => v.tax)
                          ? [{ label: "Tax collected", value: "tax" }]
                          : []
                      )
                      .concat(
                        Object.values(salesAnalytics.data).some(v => v.gst_vat)
                          ? [{ label: "GST/VAT (calculated)", value: "gst_vat" }]
                          : []
                      )
                      .concat([])}
                    data={Object.entries(salesAnalytics.data).map(([label, values]) => {
                      const inset = label[0] === "*";
                      if (inset) {
                        label = label.substring(2);
                      }

                      return {
                        rowStyle: inset
                          ? { fontStyle: "italic" }
                          : label === "total"
                            ? { fontWeight: "bold" }
                            : null,
                        //itemStyle: inset ? { marginLeft: '1em' } : null,
                        category: {
                          label: (
                            <span style={inset ? { marginLeft: "1em" } : null}>
                              {util.capitalize(label)}
                            </span>
                          ),
                          value: util.capitalize(label)
                        },
                        gross: {
                          label: util.formatPrice(values.gross, false, true),
                          value: values.gross
                        },
                        net: {
                          label: util.formatPrice(values.net, false, true),
                          value: values.net
                        },
                        fee: {
                          label: util.formatPrice(
                            values.gross - values.net - (values.deferred_fee || 0),
                            false,
                            true
                          ),
                          value: values.gross - values.net - (values.deferred_fee || 0)
                        },
                        face_sales: {
                          label: util.formatPrice(values.face_sales, false, true),
                          value: values.face_sales
                        },
                        deferred_fee: {
                          label: util.formatPrice(values.deferred_fee, false, true),
                          value: values.deferred_fee
                        },
                        stripe_fees: {
                          label: util.formatPrice(values.stripe_fees, false, true),
                          value: values.stripe_fees
                        },
                        platform_fees: {
                          label: util.formatPrice(values.platform_fees, false, true),
                          value: values.platform_fees
                        },
                        fees_absorbed: {
                          label: util.formatPrice(values.fees_absorbed, false, true),
                          value: values.fees_absorbed
                        },
                        fees_difference: {
                          label: util.formatPrice(values.fees_difference, false, true),
                          value: values.fees_difference
                        },
                        tax: {
                          label: util.formatPrice(values.tax, false, true),
                          value: values.tax
                        },
                        quantity: {
                          label: util.formatNumber(values.quantity),
                          value: values.quantity
                        },
                        quantity_active: {
                          label: util.formatNumber(values.quantity_active),
                          value: values.quantity_active
                        },
                        cash: {
                          label: util.formatPrice(values.cash, false, true),
                          value: values.cash
                        },
                        check: {
                          label: util.formatPrice(values.check, false, true),
                          value: values.check
                        },
                        credit_net: {
                          label: util.formatPrice(values.credit_net, false, true),
                          value: values.credit_net
                        },
                        gst_vat: {
                          label: util.formatPrice(values.gst_vat, false, true),
                          value: values.gst_vat
                        }
                      };
                    })}
                  />
                </div>)}
        </div>
      </div>
    );
  }
}

export default Radium(connectToStores(SalesAnalytics));


// WEBPACK FOOTER //
// ./src/app/components/sales-analytics.jsx